// Toast
import store from 'app/store';
import AppToast from 'general/components/AppToast';
import DataCommonListener from 'general/listeners/DataCommonListener';
import React, { Suspense } from 'react';
import 'react-toastify/dist/ReactToastify.css';
// router
import AppDialog from 'general/components/AppDialog';
import CustomerRoute from 'general/components/AppRoutes/CustomerRoute';
import GuestRoute from 'general/components/AppRoutes/GuestRoute';
import PrivateRoute from 'general/components/AppRoutes/PrivateRoute';
import { BrowserRouter, Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import KTPageError01 from 'general/components/OtherKeenComponents/KTPageError01';
import AppRoute from 'general/constants/AppRoute';
import ManagePaymentTransactions from 'features/ManagePaymentTransactions';
import Auth from 'features/Auth';
import ManageDealer from 'features/ManageDealer';
import ManageInvestor from 'features/ManageInvestor';
import InvestorReconciliationReport from 'features/InvestorReconciliationReport';
import ManageLandowner from 'features/ManageLandowner';
import LandownerReconciliationReport from 'features/LandownerReconciliationReport';
import AppDialogCustom from 'general/components/AppDialogCustom';
import ChargePointDetailScreen from 'features/FE/screens/ChargeConnectorDetailScreen';
import ChargePaymentQRScreen from 'features/FE/screens/ChargePaymentQRScreen';
import GuestPaymentRoute from 'general/components/AppRoutes/GuestPaymentRoute';
import ChargeTransactionDetailScreen from 'features/FE/screens/ChargeTransactionDetailScreen';
import InvestorGroupPackListScreen from 'features/ManageGroup/screens/InvestorGroupPackListScreen';
import InvestorGroupReconciliationReport from 'features/InvestorGroupReconciliationReport';
import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import AgencySaleOrderListScreen from 'features/Agency/screens/AgencySaleOrderListScreen';
import ManageAgencyTransaction from 'features/ManageAgencyTransaction';
import ManageOrder from 'features/ManageOrder';
import AgencyContractListScreen from 'features/Agency/screens/AgencyContractListScreen';
import ManageSubAgencies from 'features/ManageSubAgencies';
import ManageTransactionHistory from 'features/ManageTransactionHistory';
import InvestorGroupPackHistory from 'features/InvestorGroupPackHistory';
import ElectricityPaymentHistory from 'features/ElectricityPaymentHistory';
import ManageCommissionTransaction from 'features/ManageCommissionTransaction';
import AgencyReconciliationListScreen from 'features/Agency/screens/AgencyReconciliationListScreen';
import AgencyConfigCommissionScreen from 'features/Agency/screens/AgencyConfigCommissionScreen';
import AffiliateTree from 'features/AffiliateTree';
import ManageGroup from 'features/ManageGroup';
import ChargeStation from 'features/Charge/ChargeStation';
import ChargeBrand from 'features/Charge/ChargeBrand';
import ChargeTransaction from 'features/Charge/ChargeTransaction';
import VehicleBrand from 'features/Charge/ChargeVehicleBrand';
import ChargeVehicle from 'features/Charge/ChargeVehicle';
import ChargeRfid from 'features/Charge/ChargeRFID';
import ChargeDriver from 'features/Charge/ChargeDriver';
import ChargePricing from 'features/Charge/ChargePricing';
import ChargeSystemLog from 'features/Charge/ChargeSystemLog';
import ChargeDriverTopUpHistoryScreen from 'features/Charge/ChargeDriver/screens/ChargeDriverTopUpHistoryScreen';
import ChargeDashboard from 'features/Charge/ChargeDashboard';
import ChargeStationMapScreen from 'features/Charge/ChargeStation/screens/ChargeStationMapScreen';
import ChargeStationIframeMapScreen from 'features/Charge/ChargeStation/screens/ChargeStationIframeMapScreen';
import Staff from 'features/System/Staff';
import AgencyDashboard from 'features/Agency/screens/AgencyDashboard';
import PoaContractListScreen from 'features/System/Contract/screens/PoaContractListScreen';
import ChargeSOC from 'features/Charge/ChargeSOC';
import Account from 'features/Account';
import DashboardRoute from 'general/components/AppRoutes/DashboardRoute';
import AdminDashboardRoute from 'general/components/AppRoutes/AdminDashboardRoute';
import PermissionGroup from 'features/System/PermissionGroup';
import PushNotification from 'features/System/PushNotification';
import EnergyBill from 'features/Charge/ChargeEnergyBill';
import AgencyWithdrawScreen from 'features/Agency/screens/AgencyWithdrawScreen';
import AgencySaleDetailScreen from 'features/Agency/screens/AgencySaleDetailScreen';
import { ChargeConstants } from 'features/Charge/chargeHelper';
import { AgencyConstants } from 'features/Agency/agencyHelper';
import ReconciliationReport from 'features/ReconciliationReport';
import GroupReconciliationReport from 'features/ReconciliationReport/GroupReconciliationReport';
import ManagePremises from 'features/ManagePremises';
import Tutorial from 'features/System/InstructionConfig';
import GeneralSetting from 'features/System/GeneralSetting/screens';
import Banner from 'features/System/Banner';
import AgencyPremiseOrderListScreen from 'features/Agency/screens/AgencyPremiseOrderListScreen';
import ChargePoint from 'features/Charge/ChargePoint';
import ChargeInventory from 'features/Charge/ChargeInventory';
import ProductCategory from 'features/Charge/ProductCategory';
import ManageChargePointPartner from 'features/ManageChargePointPartner';
import LandlordReconciliationReport from 'features/ReconciliationReport/LandlordReconciliationReport';
import ChargeDriverTopupDetailScreen from 'features/FE/screens/ChargeDriverTopupDetailScreen';
import DialogTopupCompletedScreen from 'features/FE/screens/DialogTopupCompletedScreen';

import MarketingDocsScreen from 'features/Agency/screens/MarketingDocsScreen';

import ActionLog from 'features/System/ActionLog';
import RideKyc from 'features/RideKyc';
import RideDrivers from 'features/RideDrivers';
import RideTrips from 'features/RideTrips';
import RideBookings from 'features/RideBookings';
import RideDemands from 'features/RideDemands';
import RidePricing from 'features/RidePricing';
import RidePromoCodes from 'features/RidePromoCodes';
import RideReviews from 'features/RideReviews';
import RideSupportChat from 'features/RideSupportChat';
import RentalPartners from 'features/Rental';
import RentalDeposits from 'features/Rental/Deposits';
import RentalVehicleModels from 'features/Rental/VehicleModels';
import RentalRenterLicenses from 'features/Rental/RenterLicenses';
import RentalOrders from 'features/Rental/Orders';
import RentalDamageReports from 'features/Rental/DamageReports';
import RentalReconciliations from 'features/Rental/Reconciliations';
import RentalExpiredContracts from 'features/Rental/ExpiredContracts';
import CustomerHomeScreen from 'features/FE/screens/CustomerHomeScreen';
import CustomerProductDetailScreen from 'features/FE/screens/CustomerProductDetailScreen';

const customerPortalPath = '/customer/:customerTab/*';

function MobileAppRoute() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  if (searchParams.get('action')?.toLowerCase() === 'reset') {
    const resetParams = new URLSearchParams();
    const email = searchParams.get('email');
    const token = searchParams.get('token');

    if (email) resetParams.set('email', email);
    if (token) resetParams.set('token', token);

    const resetQuery = resetParams.toString();
    return (
      <Navigate
        to={`${AppRoute.auth}/reset-password${resetQuery ? `?${resetQuery}` : ''}`}
        replace
      />
    );
  }

  return (
    <GuestRoute>
      <Account />
    </GuestRoute>
  );
}

// Load BS
require('bootstrap/dist/js/bootstrap.min');
// Load KT plugins
require('assets/plugins/ktutil');
require('assets/plugins/ktmenu');
require('assets/plugins/ktoffcanvas');
require('assets/plugins/ktcookie');
require('assets/plugins/kttoggle');
// aside
require('assets/plugins/aside/aside');
require('assets/plugins/aside/aside-menu');
require('assets/plugins/aside/aside-toggle');
// header
require('assets/plugins/header/ktheader-mobile');
require('assets/plugins/header/ktheader-topbar');

window.$ = window.jQuery = require('jquery');
window.moment = require('moment');

function App() {
  const rentalEnabled = process.env.REACT_APP_RENTAL_ENABLED === 'true';

  return (
    <>
      {/* Router */}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        {/* Suspense */}
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <DashboardRoute />
                </PrivateRoute>
              }
            />

            <Route
              path="/customer-home/*"
              element={<Navigate to={AppRoute.customerHome} replace />}
            />

            <Route
              path={AppRoute.customerProductDetail}
              element={
                <CustomerRoute>
                  <CustomerProductDetailScreen />
                </CustomerRoute>
              }
            />

            <Route
              path={`${AppRoute.customerDetail}/*`}
              element={
                <PrivateRoute>
                  <ChargeDriver />
                </PrivateRoute>
              }
            />

            <Route
              path={customerPortalPath}
              element={
                <CustomerRoute>
                  <CustomerHomeScreen />
                </CustomerRoute>
              }
            />
            {/* auth */}
            <Route
              path={`${AppRoute.auth}/*`}
              element={
                <GuestRoute>
                  <Auth />
                </GuestRoute>
              }
            />

            {/* activate account */}
            <Route path={AppRoute.mobileApp} element={<MobileAppRoute />} />
            <Route path={`${AppRoute.mobileApp}/*`} element={<MobileAppRoute />} />

            <Route path={AppRoute.agencyApp} element={<MobileAppRoute />} />
            <Route path={`${AppRoute.agencyApp}/*`} element={<MobileAppRoute />} />

            {/* sac khong can tai khoan */}
            <Route path={`/prepaid/qr/:chargeConnectorSerial`} element={<ChargePointDetailScreen />} />
            <Route
              path="/prepaid/qr/payment"
              element={
                <GuestPaymentRoute>
                  <ChargePaymentQRScreen />
                </GuestPaymentRoute>
              }
            />
            <Route
              path="/prepaid/qr/transaction/:chargeTransactionId"
              element={
                <GuestPaymentRoute>
                  <ChargeTransactionDetailScreen />
                </GuestPaymentRoute>
              }
            />
            <Route
              path={`${AppRoute.dashboard}/*`}
              element={
                <PrivateRoute>
                  <AdminDashboardRoute>
                    <ChargeDashboard />
                  </AdminDashboardRoute>
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.agencyDashboard}/*`}
              element={
                <PrivateRoute>
                  <AgencyDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.stationList}/*`}
              element={
                <PrivateRoute>
                  <ChargeStation />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.pointList}/*`}
              element={
                <PrivateRoute>
                  <ChargePoint />
                </PrivateRoute>
              }
            />
            {/* ban do tram sac */}
            <Route
              path={`${AppRoute.stationsMap}/*`}
              element={
                <PrivateRoute>
                  <ChargeStationMapScreen />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.stationsMapIframe}/*`}
              element={<ChargeStationIframeMapScreen />}
            />

            {/* hoa don tien dien */}
            <Route
              path={`${AppRoute.energyBillList}/*`}
              element={
                <PrivateRoute>
                  <EnergyBill />
                </PrivateRoute>
              }
            />

            {/* hoa don mat bang */}
            <Route
              path={`${AppRoute.premisesList}/*`}
              element={
                <PrivateRoute>
                  <ManagePremises />
                </PrivateRoute>
              }
            />

            {/* quan ly phien sac */}
            <Route
              path={`${AppRoute.chargeTransactionList}/*`}
              element={
                <PrivateRoute>
                  <ChargeTransaction />
                </PrivateRoute>
              }
            />

            {/* cau hinh thong bao gui */}
            <Route
              path={`${AppRoute.pushNotificationList}/*`}
              element={
                <PrivateRoute>
                  <PushNotification />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.systemLogList}/*`}
              element={
                <PrivateRoute>
                  <ChargeSystemLog />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.productCategoryList}/*`}
              element={
                <PrivateRoute>
                  <ProductCategory />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.inventoryList}/*`}
              element={
                <PrivateRoute>
                  <ChargeInventory />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.valuationList}/*`}
              element={
                <PrivateRoute>
                  <ChargePricing />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.staffList}/*`}
              element={
                <PrivateRoute>
                  <Staff />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.tutorialList}/*`}
              element={
                <PrivateRoute>
                  <Tutorial />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.generalSetting}/*`}
              element={
                <PrivateRoute>
                  <GeneralSetting />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.manageBanner}/*`}
              element={
                <PrivateRoute>
                  <Banner />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.actionLogList}/*`}
              element={
                <PrivateRoute>
                  <ActionLog />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.rideKyc}/*`}
              element={
                <PrivateRoute>
                  <RideKyc />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.rideDrivers}/*`}
              element={
                <PrivateRoute>
                  <RideDrivers />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.rideTrips}/*`}
              element={
                <PrivateRoute>
                  <RideTrips />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.rideBookings}/*`}
              element={
                <PrivateRoute>
                  <RideBookings />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.rideDemands}/*`}
              element={
                <PrivateRoute>
                  <RideDemands />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.ridePricing}/*`}
              element={
                <PrivateRoute>
                  <RidePricing />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.ridePromoCodes}/*`}
              element={
                <PrivateRoute>
                  <RidePromoCodes />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.rideReviews}/*`}
              element={
                <PrivateRoute>
                  <RideReviews />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.rideSupportChat}/*`}
              element={
                <PrivateRoute>
                  <RideSupportChat />
                </PrivateRoute>
              }
            />
            {rentalEnabled && (
              <>
                <Route
                  path={`${AppRoute.rentalPartners}/*`}
                  element={
                    <PrivateRoute>
                      <RentalPartners />
                    </PrivateRoute>
                  }
                />
                <Route
                  path={`${AppRoute.rentalDeposits}/*`}
                  element={
                    <PrivateRoute>
                      <RentalDeposits />
                    </PrivateRoute>
                  }
                />
                <Route
                  path={`${AppRoute.rentalVehicleModels}/*`}
                  element={
                    <PrivateRoute>
                      <RentalVehicleModels />
                    </PrivateRoute>
                  }
                />
                <Route
                  path={`${AppRoute.rentalRenterLicenses}/*`}
                  element={
                    <PrivateRoute>
                      <RentalRenterLicenses />
                    </PrivateRoute>
                  }
                />
                <Route
                  path={`${AppRoute.rentalOrders}/*`}
                  element={
                    <PrivateRoute>
                      <RentalOrders />
                    </PrivateRoute>
                  }
                />
                <Route
                  path={`${AppRoute.rentalDamageReports}/*`}
                  element={
                    <PrivateRoute>
                      <RentalDamageReports />
                    </PrivateRoute>
                  }
                />
                <Route
                  path={`${AppRoute.rentalReconciliations}/*`}
                  element={
                    <PrivateRoute>
                      <RentalReconciliations />
                    </PrivateRoute>
                  }
                />
                <Route
                  path={`${AppRoute.rentalExpiredContracts}/*`}
                  element={
                    <PrivateRoute>
                      <RentalExpiredContracts />
                    </PrivateRoute>
                  }
                />
              </>
            )}

            {/* quan ly nhom quyen */}
            <Route
              path={`${AppRoute.staffPermissionList}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen sale */}
            <Route
              path={`${AppRoute.salePermissionList}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup
                    role={ChargeConstants.UserRole.AGENCY}
                    subRole={AgencyConstants.AgencyRole.SALE}
                  />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen doi tac */}
            <Route
              path={`${AppRoute.partnerPermissionList}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup
                    role={ChargeConstants.UserRole.AGENCY}
                    subRole={[
                      AgencyConstants.AgencyRole.GROUP,
                      AgencyConstants.AgencyRole.INVESTOR,
                      AgencyConstants.AgencyRole.LANDLORD,
                    ].join(',')}
                  />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen nha dau tu nhuong quyen*/}
            <Route
              path={`${AppRoute.manageGroupPermissionInvestor}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen nha dau tu HTKD*/}
            <Route
              path={`${AppRoute.manageGroupPermissionInvestorGroup}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen chu dat*/}
            <Route
              path={`${AppRoute.manageGroupPermissionLandlord}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup />
                </PrivateRoute>
              }
            />
            {/* quan ly giao dich thanh toan */}
            <Route
              path={`${AppRoute.managePaymentTransactions}/*`}
              element={
                <PrivateRoute>
                  <ManagePaymentTransactions />
                </PrivateRoute>
              }
            />

            {/* quan ly giao dich nap tien */}
            <Route
              path={`${AppRoute.customerTopUpHistory}/*`}
              element={
                <PrivateRoute>
                  <ChargeDriverTopUpHistoryScreen />
                </PrivateRoute>
              }
            />

            {/* chi tra hoa hong */}
            <Route
              path={`${AppRoute.commissionTransactionList}/*`}
              element={
                <PrivateRoute>
                  <ManageCommissionTransaction />
                </PrivateRoute>
              }
            />

            {/* quan ly giao dich dai ly */}
            <Route
              path={`${AppRoute.withdrawTransactionList}/*`}
              element={
                <PrivateRoute>
                  <ManageAgencyTransaction />
                </PrivateRoute>
              }
            />

            {/* quan ly dai ly */}
            <Route
              path={`${AppRoute.saleList}/*`}
              element={
                <PrivateRoute>
                  <ManageDealer />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.saleInfo}/*`}
              element={
                <PrivateRoute>
                  <ManageDealer isSaleInfo={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.subSaleList}/*`}
              element={
                <PrivateRoute>
                  <ManageSubAgencies role="SALE" />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.transactionHistory}/*`}
              element={
                <PrivateRoute>
                  <ManageTransactionHistory />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.saleHistory}/*`}
              element={
                <PrivateRoute>
                  <ManageDealer />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyAddOrder}`}
              element={
                <PrivateRoute>
                  <AgencySaleAddOrderScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.marketingDocs}`}
              element={
                <PrivateRoute>
                  <MarketingDocsScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyAddOrder}/:saleId`}
              element={
                <PrivateRoute>
                  <AgencySaleDetailScreen showSidebar={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.orderList}/*`}
              element={
                <PrivateRoute>
                  <ManageOrder />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyOrderList}/*`}
              element={
                <PrivateRoute>
                  <ManageOrder />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.purchaseOrder}/*`}
              element={
                <PrivateRoute>
                  <ManageOrder />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.saleOrder}/*`}
              element={
                <PrivateRoute>
                  <ManageOrder />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.customerList}/*`}
              element={
                <PrivateRoute>
                  <ChargeDriver />
                </PrivateRoute>
              }
            />

            {/* quan ly nha dau tu */}
            <Route
              path={`${AppRoute.manageInvestor}/*`}
              element={
                <PrivateRoute>
                  <ManageInvestor />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.investorList}/*`}
              element={
                <PrivateRoute>
                  <ManageInvestor />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupList}/add-order`}
              element={
                <PrivateRoute>
                  <AgencySaleAddOrderScreen removeBaseLayout={false} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupList}/*`}
              element={
                <PrivateRoute>
                  <ManageGroup />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupsList}/add-order`}
              element={
                <PrivateRoute>
                  <AgencySaleAddOrderScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupInfo}/*`}
              element={
                <PrivateRoute>
                  <ManageGroup isGroupInfo={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.subGroupList}/*`}
              element={
                <PrivateRoute>
                  <ManageSubAgencies role="GROUP" />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.investorsReport}/*`}
              element={
                <PrivateRoute>
                  <InvestorReconciliationReport />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupsReport}/*`}
              element={
                <PrivateRoute>
                  <InvestorGroupReconciliationReport />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupReport}/*`}
              element={
                <PrivateRoute>
                  <GroupReconciliationReport />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.investorInfo}/*`}
              element={
                <PrivateRoute>
                  <ManageInvestor isInvestorInfo={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.investmentPackList}/*`}
              element={
                <PrivateRoute>
                  <InvestorGroupPackListScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupPackHistory}/*`}
              element={
                <PrivateRoute>
                  <InvestorGroupPackHistory />
                </PrivateRoute>
              }
            />

            {/* quan ly chu dat */}
            <Route
              path={`${AppRoute.landlordList}/*`}
              element={
                <PrivateRoute>
                  <ManageLandowner />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.landlordInfo}/*`}
              element={
                <PrivateRoute>
                  <ManageLandowner isLandlordInfo={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.electricityPayment}/*`}
              element={
                <PrivateRoute>
                  <ElectricityPaymentHistory />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.landlordsReport}/*`}
              element={
                <PrivateRoute>
                  <LandownerReconciliationReport />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.landlordReport}/*`}
              element={
                <PrivateRoute>
                  <LandlordReconciliationReport />
                </PrivateRoute>
              }
            />

            {/* quan ly doi tac mua tru sac */}
            <Route
              path={`${AppRoute.chargePointPartnerList}/*`}
              element={
                <PrivateRoute>
                  <ManageChargePointPartner />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.manageVehicleBrand}/*`}
              element={
                <PrivateRoute>
                  <VehicleBrand />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.vehicleList}/*`}
              element={
                <PrivateRoute>
                  <ChargeVehicle />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.rfidList}/*`}
              element={
                <PrivateRoute>
                  <ChargeRfid />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.manageChargeBrand}/*`}
              element={
                <PrivateRoute>
                  <ChargeBrand />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.superDashboard}/*`}
              element={
                <PrivateRoute>
                  <ChargeSOC />
                </PrivateRoute>
              }
            />
            {/* quybka */}
            {/* agency sale add order */}
            <Route
              path={`${AppRoute.agencySaleAddOrder}`}
              element={
                <PrivateRoute>
                  <AgencySaleAddOrderScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencySaleAddOrder}/:saleId`}
              element={
                <PrivateRoute>
                  <AgencySaleAddOrderScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencySaleOrderList}/*`}
              element={
                <PrivateRoute>
                  <AgencySaleOrderListScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencySaleOrderDetail}/:saleId`}
              element={
                <PrivateRoute>
                  <AgencySaleDetailScreen showSidebar={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.premiseOrderList}`}
              element={
                <PrivateRoute>
                  <AgencyPremiseOrderListScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.premiseOrderList}/:saleId`}
              element={
                <PrivateRoute>
                  <AgencySaleDetailScreen showSidebar={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyContractList}/*`}
              element={
                <PrivateRoute>
                  <AgencyContractListScreen />
                </PrivateRoute>
              }
            />

            {/* ds bao cao doi soat */}
            <Route
              path={`${AppRoute.agencyReconciliationList}`}
              element={
                <PrivateRoute>
                  <AgencyReconciliationListScreen />
                </PrivateRoute>
              }
            />

            {/* cau hinh hoa hong */}
            <Route
              path={`${AppRoute.agencyConfigCommission}/*`}
              element={
                <PrivateRoute>
                  <AgencyConfigCommissionScreen />
                </PrivateRoute>
              }
            />

            {/* cay he thong affiliate */}
            <Route
              path={`${AppRoute.affiliateTree}/*`}
              element={
                <PrivateRoute>
                  <AffiliateTree />
                </PrivateRoute>
              }
            />

            {/* hoa don tien dien */}
            <Route
              path={`${AppRoute.energyBillList}/*`}
              element={
                <PrivateRoute>
                  <EnergyBill />
                </PrivateRoute>
              }
            />

            {/* danh sach hop dong */}
            <Route
              path={`${AppRoute.contractList}/*`}
              element={
                <PrivateRoute>
                  <AgencyContractListScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.poaContract}`}
              element={
                <PrivateRoute>
                  <PoaContractListScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.withdrawTransaction}/*`}
              element={
                <PrivateRoute>
                  <AgencyWithdrawScreen />
                </PrivateRoute>
              }
            />

            {/* bao cao doi soat */}
            <Route
              path={`${AppRoute.reconciliationReport}/*`}
              element={
                <PrivateRoute>
                  <ReconciliationReport />
                </PrivateRoute>
              }
            />
            {/* nap tien qua ma qr */}
            <Route path={`/topup/:serialNumber`} element={<ChargeDriverTopupDetailScreen />} />
            <Route
              path="/topup/:serialNumber/payment"
              element={
                <GuestPaymentRoute>
                  <ChargePaymentQRScreen />
                </GuestPaymentRoute>
              }
            />
            <Route path={`/payment/vnpay/completed`} element={<DialogTopupCompletedScreen />} />

            <Route path="*" element={<KTPageError01 />} />
          </Routes>
        </Suspense>
      </BrowserRouter>

      {/* App Dialog */}
      <AppDialog />
      <AppDialogCustom />
      {/* Toast */}
      <AppToast />
      {/* Listener */}
      <DataCommonListener />

      {/* eKYC div */}
      <div id="eKYC_div"></div>
    </>
  );
}

export default App;
